import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';

const CGVPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    navigate('/');
  };

  return (
    <div className="mentions-legales-page">
      <div className="mentions-container">
        <button className="back-btn" onClick={goBack}>
          <ArrowLeft size={20} />
          Retour à l'accueil
        </button>

        <h1>Conditions Générales de Vente et d'Utilisation</h1>
        <p className="last-update">Dernière mise à jour : Janvier 2025</p>

        <section>
          <h2>1. Objet</h2>
          <p>
            Les présentes Conditions Générales de Vente et d'Utilisation (ci-après "CGV/CGU") régissent 
            l'utilisation du service MonCoach accessible sur le site moncoach.eu, édité par la société NOTHING.
          </p>
          <p>
            En vous inscrivant et en utilisant le service, vous acceptez sans réserve les présentes CGV/CGU.
          </p>
        </section>

        <section>
          <h2>2. Présentation du service</h2>
          <p>
            MonCoach est un service d'accompagnement nutritionnel personnalisé qui propose :
          </p>
          <div className="info-block">
            <p>• Des échanges avec Louis, votre coach nutrition personnel</p>
            <p>• Des plans de repas personnalisés</p>
            <p>• Un journal alimentaire avec calcul automatique des calories</p>
            <p>• Un scanner nutritionnel de plats</p>
            <p>• Un suivi de poids et de progression</p>
            <p>• Des défis et conseils nutritionnels</p>
          </div>
        </section>

        <section>
          <h2>3. Inscription et compte utilisateur</h2>
          <h3>3.1 Conditions d'inscription</h3>
          <p>
            Pour utiliser MonCoach, vous devez être âgé d'au moins 16 ans et fournir une adresse email valide.
          </p>
          <h3>3.2 Sécurité du compte</h3>
          <p>
            Vous êtes responsable de la confidentialité de vos identifiants de connexion. 
            Toute activité réalisée depuis votre compte est présumée effectuée par vous.
          </p>
          <h3>3.3 Exactitude des informations</h3>
          <p>
            Vous vous engagez à fournir des informations exactes et à les maintenir à jour, 
            notamment concernant vos données de santé (poids, allergies, etc.).
          </p>
        </section>

        <section>
          <h2>4. Offres et tarifs</h2>
          <h3>4.1 Offre Gratuite</h3>
          <div className="info-block">
            <p>L'offre gratuite inclut :</p>
            <p>• 20 échanges avec Louis par mois</p>
            <p>• 5 repas analysés par mois (Journal)</p>
            <p>• 3 scans de plats par mois</p>
            <p>• 1 plan de repas par mois</p>
          </div>
          
          <h3>4.2 Offre Pro</h3>
          <div className="info-block">
            <p>L'abonnement Pro donne accès à :</p>
            <p>• Échanges illimités avec Louis</p>
            <p>• Journal alimentaire illimité</p>
            <p>• Scans de plats illimités</p>
            <p>• Plans de repas illimités</p>
            <p>• Suivi du poids</p>
            <p>• Défis personnalisés</p>
          </div>
          
          <h3>4.3 Tarifs</h3>
          <div className="info-block">
            <p>• <strong>Abonnement mensuel :</strong> 8,99 € TTC / mois</p>
            <p>• <strong>Abonnement annuel :</strong> 54,99 € TTC / an (soit 4,58 € / mois)</p>
          </div>
          <p>
            Les tarifs peuvent être modifiés à tout moment. Les modifications s'appliqueront 
            aux nouveaux abonnements et aux renouvellements après notification préalable.
          </p>
        </section>

        <section>
          <h2>5. Essai gratuit</h2>
          <p>
            Un essai gratuit de 7 jours peut être proposé pour l'offre Pro. À l'issue de cette période, 
            votre abonnement sera automatiquement renouvelé au tarif en vigueur, sauf annulation de votre part.
          </p>
          <p>
            <strong>Important :</strong> L'essai gratuit n'est disponible qu'une seule fois par utilisateur.
          </p>
        </section>

        <section>
          <h2>6. Paiement</h2>
          <h3>6.1 Moyens de paiement</h3>
          <p>
            Les paiements sont effectués par carte bancaire via notre prestataire sécurisé Stripe.
          </p>
          <h3>6.2 Facturation</h3>
          <p>
            Une facture est disponible dans votre espace personnel après chaque paiement.
          </p>
          <h3>6.3 Renouvellement automatique</h3>
          <p>
            Les abonnements sont renouvelés automatiquement à leur date d'échéance. 
            Vous pouvez désactiver le renouvellement automatique à tout moment depuis votre compte.
          </p>
        </section>

        <section>
          <h2>7. Droit de rétractation</h2>
          <p>
            Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation 
            ne peut être exercé pour les services pleinement exécutés avant la fin du délai de rétractation 
            et dont l'exécution a commencé avec votre accord préalable.
          </p>
          <p>
            En acceptant de commencer à utiliser le service immédiatement, vous renoncez expressément 
            à votre droit de rétractation.
          </p>
        </section>

        <section>
          <h2>8. Résiliation</h2>
          <h3>8.1 Par l'utilisateur</h3>
          <p>
            Vous pouvez résilier votre abonnement à tout moment depuis votre espace personnel. 
            La résiliation prendra effet à la fin de la période en cours.
          </p>
          <h3>8.2 Par MonCoach</h3>
          <p>
            Nous nous réservons le droit de suspendre ou résilier votre compte en cas de :
          </p>
          <div className="info-block">
            <p>• Non-respect des présentes CGV/CGU</p>
            <p>• Utilisation frauduleuse ou abusive du service</p>
            <p>• Non-paiement des sommes dues</p>
          </div>
        </section>

        <section>
          <h2>9. Utilisation du service</h2>
          <h3>9.1 Règles d'utilisation</h3>
          <p>Vous vous engagez à :</p>
          <div className="info-block">
            <p>• Utiliser le service de manière loyale et conforme à sa destination</p>
            <p>• Ne pas tenter de contourner les limitations techniques</p>
            <p>• Ne pas partager votre compte avec des tiers</p>
            <p>• Ne pas utiliser le service à des fins illégales</p>
          </div>
          
          <h3>9.2 Contenu utilisateur</h3>
          <p>
            Vous restez propriétaire des données que vous saisissez dans le service. 
            Vous nous accordez une licence d'utilisation limitée pour fournir le service.
          </p>
        </section>

        <section>
          <h2>10. Avertissement santé</h2>
          <div className="info-block" style={{background: '#fef3c7', border: '1px solid #f59e0b'}}>
            <p><strong>⚠️ Important</strong></p>
            <p>
              MonCoach fournit des conseils nutritionnels à titre informatif uniquement. 
              Ces conseils ne remplacent en aucun cas l'avis d'un médecin, nutritionniste 
              ou professionnel de santé.
            </p>
            <p>
              Avant d'entreprendre tout régime alimentaire ou programme de perte de poids, 
              consultez un professionnel de santé, particulièrement si vous avez des problèmes 
              de santé, êtes enceinte ou allaitez.
            </p>
          </div>
        </section>

        <section>
          <h2>11. Limitation de responsabilité</h2>
          <p>
            MonCoach ne saurait être tenu responsable :
          </p>
          <div className="info-block">
            <p>• Des dommages résultant d'une mauvaise utilisation du service</p>
            <p>• Des dommages liés à l'application des conseils nutritionnels sans avis médical</p>
            <p>• Des interruptions temporaires du service pour maintenance</p>
            <p>• Des dommages causés par des tiers ou des circonstances indépendantes de notre volonté</p>
          </div>
          <p>
            Notre responsabilité est limitée au montant des sommes effectivement versées 
            au cours des 12 derniers mois.
          </p>
        </section>

        <section>
          <h2>12. Propriété intellectuelle</h2>
          <p>
            L'ensemble des éléments du service (textes, images, logiciels, marques, etc.) 
            sont la propriété exclusive de NOTHING ou de ses partenaires.
          </p>
          <p>
            Toute reproduction ou utilisation non autorisée est interdite.
          </p>
        </section>

        <section>
          <h2>13. Protection des données</h2>
          <p>
            Vos données personnelles sont traitées conformément à notre Politique de Confidentialité 
            et au Règlement Général sur la Protection des Données (RGPD).
          </p>
        </section>

        <section>
          <h2>14. Modification des CGV/CGU</h2>
          <p>
            Nous pouvons modifier les présentes CGV/CGU à tout moment. Les modifications 
            entreront en vigueur 30 jours après leur publication ou à la date de votre 
            prochaine utilisation du service si elle est postérieure.
          </p>
        </section>

        <section>
          <h2>15. Droit applicable et litiges</h2>
          <p>
            Les présentes CGV/CGU sont soumises au droit français.
          </p>
          <p>
            En cas de litige, nous vous invitons à nous contacter pour trouver une solution amiable. 
            À défaut, vous pouvez recourir à une médiation de la consommation ou saisir les tribunaux compétents.
          </p>
          <p>
            <strong>Médiateur de la consommation :</strong> Conformément aux articles L.611-1 et suivants 
            du Code de la consommation, vous pouvez recourir gratuitement au service de médiation MEDICYS.
          </p>
        </section>

        <section>
          <h2>16. Contact</h2>
          <div className="info-block">
            <p><strong>NOTHING</strong></p>
            <p>58 rue de Monceau, 75008 Paris, France</p>
            <p>Email : contact@moncoach.eu</p>
            <p>SIREN : 892 798 208</p>
          </div>
        </section>

        <div className="legal-nav">
          <p>Autres pages légales :</p>
          <div className="legal-links">
            <Link to="/mentions-legales">Mentions légales</Link>
            <Link to="/confidentialite">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CGVPage;
